export default "__VITE_ASSET__7ba4e5e7__"